import React from 'react';
import classnames from 'classnames';
import DropdownMenu from './DropdownMenu';
import DropdownMenuItem from './DropdownMenuItem';

const options = [
  {
    label: 'Last 7 days',
    value: 'SEVEN_DAYS',
    className: 'campaign_dropdown',
  },
  {
    label: 'Last 4 weeks',
    value: 'FOUR_WEEKS',
    className: 'campaign_dropdown',
  },
  {
    label: 'Last 6 months',
    value: 'SIX_MONTHS',
    className: 'campaign_dropdown',
  },
];
const StatusSelectDropdown = ({
  onChange,
  selectedOption,
  dropdownMenu,
  ...rest
}) => {
  return (
    <DropdownMenu {...rest}>
      {options.map((item, index) => (
        <DropdownMenuItem
          label={item.label}
          key={index}
          value={item.value}
          onClick={onChange}
          type="BUTTON"
          className={classnames(item.className, { 'active': selectedOption === item.value })}
        />
      ))}
    </DropdownMenu>
  );
};

export default StatusSelectDropdown;
